// ─── Écran d'accueil (Core) ───────────────────────────────────────
// Volontairement vide : c'est la page que chaque nouvelle app remplacera.
import React, { useMemo } from 'react';
import { View, Text, StyleSheet } from 'react-native';
import { useUI } from '../theme/PreferencesUI';
import { useT } from '../i18n/LangueContext';
import { useApp } from '../app/AppContext';

export default function EcranBienvenue() {
  const UI = useUI();
  const t = useT();
  const app = useApp();
  const s = useMemo(() => makeStyles(UI), [UI]);
  return (
    <View style={s.page}>
      <Text style={s.titre}>{t('commun.bienvenueSuite')}</Text>
      <Text style={s.sous}>{app.nom} · v{app.version}</Text>
    </View>
  );
}

const makeStyles = (UI) => StyleSheet.create({
  page:  { flex: 1, backgroundColor: UI.bg, alignItems: 'center', justifyContent: 'center', padding: 24 },
  titre: { fontSize: 24, fontWeight: '800', color: UI.ink, textAlign: 'center' },
  sous:  { fontSize: 13, color: UI.faint, marginTop: 8 },
});
